export default __webpack_public_path__ + "static/third-party.url-d22ddf6f70afdc86664eacb4f0fba584.svg";